// Module
var code = `<form name="\$ctrl.form" novalidate>
  <div class="form-section">
    <form-section form-title="'Product info'">
      <form-section-field field-title="'Name'">
        <input
          type="text"
          ng-model="\$ctrl.loanProduct.productDefinition.productName"
          required
          ng-minlength="1"
          ng-maxlength="64"/>
      </form-section-field>
      <form-section-field field-title="'Description'">
        <input
          type="text"
          ng-model="\$ctrl.loanProduct.productDefinition.description"
          ng-maxlength="512"/>
      </form-section-field>
      <form-section-field field-title="'Code'">
        <input
          type="text"
          ng-model="\$ctrl.loanProduct.productDefinition.productTypeCode"
          required
          minlength="1"
          maxlength="4"/>
      </form-section-field>
      <form-section-field field-title="'Per customer limit (0 for unlimited)'">
        <input
          required
          type="number"
          ng-model="\$ctrl.loanProduct.productDefinition.perCustomerLimit"
          min="0"
        />
      </form-section-field>
    </form-section>

    <form-section form-title="'Core parameters'">
      <form-section-field field-title="'Microfinance loan'">
        <select
          ng-model="\$ctrl.loanProduct.microfinance"
          ng-options="o.value as o.label for o in [{ label: 'No', value: false }, { label: 'Yes', value: true }]">
        </select>
      </form-section-field>
      <form-section-field field-title="'With collateral'">
        <select
          ng-model="\$ctrl.loanProduct.collateralRequirement"
          ng-options="o.value as (o.label | translate:'LOAN') for o in \$ctrl.collateralRequirements">
        </select>
      </form-section-field>
      <form-section-field field-title="'Minimum amount'">
        <cash ng-model="\$ctrl.loanProduct.minAmount"
              required></cash>
      </form-section-field>
      <form-section-field field-title="'Maximum amount'">
        <cash
          ng-model="\$ctrl.loanProduct.maxAmount"
          min="\$ctrl.loanProduct.minAmount"
          required></cash>
      </form-section-field>
      <form-section-field field-title="'Minimum term'">
        <glue-container append="'days'">
          <input
            type="number"
            required
            placeholder="Minimum term"
            ng-model="\$ctrl.loanProduct.minTerm"
            min="1"/>
        </glue-container>
      </form-section-field>
      <form-section-field field-title="'Maximum term'">
        <glue-container append="'days'">
          <input
            type="number"
            required
            ng-min="\$ctrl.loanProduct.minTerm"
            min="1"
            ng-max="\$ctrl.maxIntegerValue"
            placeholder="Maximum term"
            ng-model="\$ctrl.loanProduct.maxTerm"/>
        </glue-container>
      </form-section-field>
      <form-section-field field-title="'Term calculation'">
        <select
          ng-model="\$ctrl.loanProduct.termCalculationMethod"
          ng-options="o.value as o.label for o in [{ label: 'Based on interval', value: 'INTERVAL' }, { label: 'Based on exact days', value: 'EXACT_DAYS' }]",
          required
        >
        </select>
      </form-section-field>

      <form-section-field ng-if="\$ctrl.loanProduct.termCalculationMethod === 'INTERVAL'"
                          field-title="'Calculate maturity date by term'">
        <select
          ng-model="\$ctrl.loanProduct.calculateMaturityDateByTerm"
          boolean-options
          required
        >
        </select>
      </form-section-field>

      <form-section-field field-title="'Allow renewal'">
        <select
          ng-model="\$ctrl.loanProduct.allowRenewal"
          ng-change="\$ctrl.onRenewalAllowedChange()"
          boolean-options
          required
        >
        </select>
      </form-section-field>

      <form-section-field ng-if="\$ctrl.loanProduct.allowRenewal"
                          field-title="'Required paid principal percentage for renewal'">
        <glue-container append-percentage="true">
          <input type="number"
                 min="0.01"
                 max="100"
                 ng-model="\$ctrl.loanProduct.renewalMinPaidPrincipalPercentage"
                 ng-required="true"
                 step="0.01"
          />
        </glue-container>
      </form-section-field>

      <form-section-field field-title="'Allow payment rescheduling (reconstruction)'">
        <select
          ng-model="\$ctrl.loanProduct.allowReconstruction"
          boolean-options
          required
        >
        </select>
      </form-section-field>
      <form-section-field ng-if="\$ctrl.hasReportingToolReports || \$ctrl.loanProduct.sendEmailDocumentsOnRelease" field-title="'Should send email documents to customer on loan release?'">
        <select
          ng-model="\$ctrl.loanProduct.sendEmailDocumentsOnRelease"
          boolean-options
          ng-required="true">
        </select>
      </form-section-field>
    </form-section>
  </div>

  <div class="form-section">
    <form-section form-title="'Cycle counting'">
      <form-section-field field-title="'Cycle counting enabled?'">
        <select
          ng-model="\$ctrl.loanProduct.cycleCounting"
          boolean-options
          required>
        </select>
      </form-section-field>
      <loan-cycle-counter loan-type="\$ctrl.loanProduct" form="\$ctrl.form"></loan-cycle-counter>
      <div class="alert" ng-if="\$ctrl.loanProduct.cycleCounting">
        The value set in this section will override the max. principal amount.
      </div>
    </form-section>

    <form-section form-title="'Contractual savings'">
      <form-section-field field-title="'With contractual savings'">
        <select ng-model="\$ctrl.loanProduct.withContractualSavings"
                boolean-options
                ng-change="\$ctrl.withContractualSavingsOnChange()"
                ng-required="true">
        </select>
      </form-section-field>

      <form-section-field field-title="'Assignment strategy'"
                          ng-if="\$ctrl.loanProduct.withContractualSavings">
        <select
          ng-model="\$ctrl.loanProduct.contractualSavingsAssignmentStrategy"
          ng-options="o.value as (o.label | translate:'LOAN') for o in \$ctrl.assignmentStrategies"
          ng-required="true"></select>
      </form-section-field>

      <form-section-field field-title="'Individual CBU Account Type'"
                          ng-if="\$ctrl.loanProduct.withContractualSavings">
        <select
          ng-model="\$ctrl.loanProduct.individualCbuAccountTypeId"
          ng-options="o.value as o.label for o in \$ctrl.individualCbuTypes"
          ng-required="false"></select>
      </form-section-field>
      <form-section-field field-title="'Corporate CBU Account Type'"
                          ng-if="\$ctrl.loanProduct.withContractualSavings">
        <select
          ng-model="\$ctrl.loanProduct.corporateCbuAccountTypeId"
          ng-options="o.value as o.label for o in \$ctrl.corporateCbuTypes"
          ng-required="false"></select>
      </form-section-field>

      <form-section-field field-title="'Individual PF Account Type'"
                          ng-if="\$ctrl.loanProduct.withContractualSavings">
        <select
          ng-model="\$ctrl.loanProduct.individualPfAccountTypeId"
          ng-options="o.value as o.label for o in \$ctrl.individualPfTypes"
          ng-required="false"></select>
      </form-section-field>
      <form-section-field field-title="'Corporate PF Account Type'"
                          ng-if="\$ctrl.loanProduct.withContractualSavings">
        <select
          ng-model="\$ctrl.loanProduct.corporatePfAccountTypeId"
          ng-options="o.value as o.label for o in \$ctrl.corporatePfTypes"
          ng-required="false"></select>
      </form-section-field>

      <form-section-field field-title="'Individual TP Account Type'"
                          ng-if="\$ctrl.loanProduct.withContractualSavings">
        <select
          ng-model="\$ctrl.loanProduct.individualTpAccountTypeId"
          ng-options="o.value as o.label for o in \$ctrl.individualTpTypes"
          ng-required="false"></select>
      </form-section-field>
      <form-section-field field-title="'Corporate TP Account Type'"
                          ng-if="\$ctrl.loanProduct.withContractualSavings">
        <select
          ng-model="\$ctrl.loanProduct.corporateTpAccountTypeId"
          ng-options="o.value as o.label for o in \$ctrl.corporateTpTypes"
          ng-required="false"></select>
      </form-section-field>

      <form-section-field field-title="'Auto hold?'" ng-if="\$ctrl.hasCSAccountSet()">
        <select
          ng-model="\$ctrl.loanProduct.autoHold"
          ng-change="\$ctrl.onAutoHoldChange()"
          boolean-options
          ng-required="true">
        </select>
      </form-section-field>
      <form-section-field field-title="'Ignore cs when calculating loan status'"
                          ng-if="\$ctrl.loanProduct.withContractualSavings">
        <select
          ng-model="\$ctrl.loanProduct.ignoreCSWhenCalculatingLoanStatus"
          boolean-options
          required
        >
        </select>
      </form-section-field>

      <form-section-field field-title="'Ignore cs when calculating amortization status:'"
                          ng-if="\$ctrl.loanProduct.withContractualSavings">
        <select
          ng-model="\$ctrl.loanProduct.ignoreCSWhenCalculatingAmortizationStatus"
          boolean-options
          required
        >
        </select>
      </form-section-field>

      <form-section-field field-title="'Auto hold release method'"
                          ng-if="\$ctrl.loanProduct.autoHold">
        <select
          ng-model="\$ctrl.loanProduct.autoHoldReleaseMethod"
          ng-options="value | prettyEnum for value in \$ctrl.autoHoldReleaseMethods"
          ng-required="true">
        </select>
      </form-section-field>


      <form-section-field field-title="'Auto hold type'"
                          ng-if="\$ctrl.loanProduct.autoHold">
        <select
          ng-model="\$ctrl.loanProduct.autoHoldType"
          ng-options="value | prettyEnum for value in \$ctrl.autoHoldTypes"
          ng-required="true">
        </select>
      </form-section-field>

      <form-section-field
        ng-if="\$ctrl.loanProduct.autoHoldType === 'FIXED'"
        field-title="'Amount'">
        <cash ng-model="\$ctrl.loanProduct.autoHoldFixedAmount"
              min="0.01"
              ng-required="true"></cash>
      </form-section-field>

      <form-section-field
        ng-if="\$ctrl.loanProduct.autoHoldType === 'PERCENTAGE'"
        field-title="'Percentage'">
        <glue-container append-percentage="true">
          <input type="number"
                 ng-model="\$ctrl.loanProduct.autoHoldPercentage"
                 ng-min="0.01"
                 ng-required="true"/>
        </glue-container>
      </form-section-field>
      <form-section-field
        ng-if="\$ctrl.loanProduct.autoHoldType === 'PERCENTAGE'"
        field-title="'Auto hold calculation method'">
        <select ng-model="\$ctrl.loanProduct.autoHoldCalculationMethod"
                ng-options="value | prettyEnum for value in \$ctrl.autoHoldCalculationMethods"
                ng-required="true">
        </select>
      </form-section-field>

    </form-section>

    <form-section form-title="'Linked deposit account'">
      <form-section-field field-title="'With linked deposit account'">
        <select ng-model="\$ctrl.loanProduct.withLinkedDepositAccount"
                boolean-options
                ng-required="true">
        </select>
      </form-section-field>
    </form-section>

    <form-section form-title="'Product management'">
      <product-availability branches-to-select="\$ctrl.branches"
                            product-availability="\$ctrl.loanProduct.productDefinition.productAvailability"
                            available-in-branch-ids="\$ctrl.loanProduct.productDefinition.availableInBranchIds"></product-availability>
      <form-section-field field-title="'Allow product creation by agents'">
        <select
          ng-model="\$ctrl.loanProduct.productDefinition.allowCreationByAgents"
          boolean-options
          disabled
          required>
        </select>
      </form-section-field>
      <customer-type-constraint
        customer-type-constraints="\$ctrl.loanProduct.productDefinition.customerTypeConstraints"
        product-type="'LOAN'">
      </customer-type-constraint>
      <form-section-field field-title="'Product already expired?'">
        <select
          ng-model="\$ctrl.loanProduct.productDefinition.expired"
          boolean-options
          ng-disabled="!\$ctrl.loanProduct.id"
          required>
        </select>
      </form-section-field>
      <form-section-field field-title="'Available for credit line?'">
        <select
          ng-model="\$ctrl.loanProduct.creditLineAvailable"
          boolean-options
          ng-required="true">
        </select>
      </form-section-field>
      <form-section-field field-title="'Product is for Employees?'">
        <select
          ng-model="\$ctrl.loanProduct.productDefinition.employeeProduct"
          boolean-options
          ng-required="true">
        </select>
      </form-section-field>
    </form-section>


    <form-section form-title="'Deped loans'">
      <form-section-field field-title="'Deped loan'">
        <select ng-model="\$ctrl.loanProduct.depEd"
                boolean-options
                ng-required="true">
        </select>
      </form-section-field>
      <form-section-field field-title="'Policy number generation method'" ng-if="\$ctrl.loanProduct.depEd">
        <select ng-model="\$ctrl.loanProduct.depEdPolicyNumberStrategy"
                ng-options="s.value as s.label for s in \$ctrl.depEdPolicyNumberStrategies"
                ng-required="true">
        </select>
      </form-section-field>
      <form-section-field field-title="'Policy number pattern'"
                          ng-if="\$ctrl.loanProduct.depEd && \$ctrl.loanProduct.depEdPolicyNumberStrategy === 'AUTOMATIC'">
        <number-pattern ng-model="\$ctrl.loanProduct.depEdPolicyNumberPattern"
                               length="14"
                               options="\$ctrl.depEdPolicyNumberOptions"
                               required
        >
        </number-pattern>
      </form-section-field>
    </form-section>
  </div>
</form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/loan/details/forms/loan-product-general.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;